import { apiFetch, apiFetchBlob } from "./client.js";

/**
 * Contrato del canal de chat de wa-cloud-bridge (ver GUIA_CONEXION_CHAT_WEB.md).
 * /start emite sessionToken; el resto va con Authorization: Bearer.
 */

export function startConversation({ sessionId, source, auth, linkToken, turnstileToken } = {}) {
  const body = { sessionId, source };
  if (turnstileToken) {
    body.turnstileToken = turnstileToken;
  }
  if (auth?.numero_abonado && auth?.token) {
    body.numero_abonado = auth.numero_abonado;
    body.token = auth.token;
  }
  if (linkToken) {
    body.linkToken = linkToken;
  }
  return apiFetch("/api/chat/start", { method: "POST", body, timeoutMs: 15_000 });
}

export function sendChatMessage(conversationId, message) {
  return apiFetch(`/api/chat/${conversationId}/message`, {
    method: "POST",
    body: { message }
  });
}

export function sendChatMedia(conversationId, { fileName, mimeType, dataBase64, caption }) {
  return apiFetch(`/api/chat/${conversationId}/media`, {
    method: "POST",
    body: { fileName, mimeType, dataBase64, caption },
    timeoutMs: 45_000
  });
}

/**
 * Descarga un adjunto de la conversación (cupón, factura o archivo de agente).
 * 404 si no pertenece a esta conversación, 410 si venció (30 días).
 */
export function downloadChatAttachment(conversationId, attachmentId) {
  return apiFetchBlob(`/api/chat/${conversationId}/attachments/${attachmentId}`, { timeoutMs: 45_000 });
}

/**
 * Una página del historial, de la más nueva hacia atrás.
 *
 * Para pedir la anterior se reenvía tal cual el `nextBefore` de la respuesta
 * previa: `getChatHistory(id, history.nextBefore)`. Sin cursor devuelve la
 * página más reciente. El alcance (sólo esta sesión, o el hilo del abonado
 * validado en otros dispositivos) lo decide el server y viene en `scope`.
 */
export function getChatHistory(conversationId, { limit = 50, before = null, beforeId = null } = {}) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before && beforeId) {
    params.set("before", before);
    params.set("beforeId", beforeId);
  }
  return apiFetch(`/api/chat/${conversationId}/history?${params.toString()}`, { timeoutMs: 10_000 });
}

export function getChatStatus(conversationId) {
  return apiFetch(`/api/chat/${conversationId}`, { timeoutMs: 10_000 });
}

// Revoca el registro de este dispositivo (cookie httpOnly flux_device): se
// usa al "cerrar sesión" para que otra cuenta no herede la identificación.
export function forgetDeviceRegistration(conversationId) {
  return apiFetch(`/api/chat/${conversationId}/device/forget`, {
    method: "POST",
    timeoutMs: 10_000
  });
}

// ── Web Push ────────────────────────────────────────────────────────────────

// { enabled, publicKey } — enabled:false = el server no tiene claves VAPID.
export function getPushConfig() {
  return apiFetch("/api/chat/push/config", { timeoutMs: 10_000 });
}

// subscription = PushSubscription.toJSON(): { endpoint, keys: { p256dh, auth } }
export function savePushSubscription(conversationId, subscription) {
  return apiFetch(`/api/chat/${conversationId}/push/subscription`, {
    method: "POST",
    body: subscription,
    timeoutMs: 10_000
  });
}
